module.exports = __webpack_public_path__ + "img/audio-bg.570f79ca.png";